module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-3.jpg?927cd76b";